const GENERIC = "Something went wrong. Please try again.";

// Laravel's umbrella text for a validation failure. On its own it tells the
// user nothing, so it is only used when no field message is available.
const LARAVEL_UMBRELLA = "The given data was invalid.";

/**
 * Turns an API response body into a message worth showing the user.
 *
 * Laravel replies to a failed request with:
 *   { "message": "...", "errors": { "email": ["The email must be ..."] } }
 *
 * The field messages are the useful part, and which field carries them
 * depends on what the user got wrong. Reading one hard-coded field, as this
 * code used to, throws whenever the problem is a different field and hides
 * the reason whenever it is not.
 */
export function getApiErrorMessage(body, fallback = GENERIC) {
  if (!body || typeof body !== "object") {
    return fallback;
  }

  if (body.errors && typeof body.errors === "object") {
    const messages = [];
    Object.keys(body.errors).forEach((field) => {
      const value = body.errors[field];
      const list = Array.isArray(value) ? value : [value];
      list.forEach((message) => {
        // Deduplicated: the same text can be repeated under several fields.
        if (
          typeof message === "string" &&
          message.trim() &&
          messages.indexOf(message) === -1
        ) {
          messages.push(message);
        }
      });
    });
    if (messages.length) {
      return messages.join(" ");
    }
  }

  if (
    typeof body.message === "string" &&
    body.message.trim() &&
    body.message !== LARAVEL_UMBRELLA
  ) {
    return body.message;
  }

  return fallback;
}

/**
 * Same, for an axios rejection, where the body sits under error.response.data.
 */
export function getAxiosErrorMessage(error, fallback = GENERIC) {
  const body = error && error.response ? error.response.data : null;
  return getApiErrorMessage(body, fallback);
}
